import React from "react";
import PropTypes from "prop-types";

import { getEltAndAccessorNumber } from "./common/helpers";
import DataGrid from "../../Components/DataGrid";
import { caseInsensitiveFilter } from "./common/ResourcesTable";

import "./common/ResourcesTable.scss";

/*
Constants and Helpers
*/

export const getRows = ({
  data,
  // onClickIp = () => () => {},
}) => {
  const rows = data.map((elt) => {
    const {
      groupedCount: total,

      windowsEventId,

      windowsLogSource: source,
    } = elt;

    // Log source
    const sourceElt = <div>{source}</div>;

    // Total
    const { accessor: totalAccessor, element: totalElt } =
      getEltAndAccessorNumber(total);

    // Windows event
    const windowsEventElt = <div>{windowsEventId}</div>;

    return {
      source: sourceElt,
      sourceAccessor: source,

      windowsEvt: windowsEventElt,
      windowsEventAccessor: windowsEventId,

      total: totalElt,
      totalAccessor,
    };
  });

  return rows;
};

const COLUMNS = [
  {
    Header: "Windows Event ID",
    accessor: "windowsEventAccessor",
    filterable: true,
    sortable: true,
    Cell: (row) => row.original.windowsEvt,
    filterMethod: caseInsensitiveFilter(),
  },
  {
    Header: "Log Source",
    accessor: "sourceAccessor",
    filterable: true,
    sortable: true,
    Cell: (row) => row.original.source,
    filterMethod: caseInsensitiveFilter(),
    maxWidth: 195,
    minWidth: 120,
  },
  {
    Header: "Total",
    accessor: "totalAccessor",
    filterable: false,
    sortable: true,
    Cell: (row) => row.original.total,
    filterMethod: caseInsensitiveFilter(),
  },
];

/*
Component
*/

const WindowsEvtsTable = (props) => {
  const { data } = props;

  return (
    <div className="resources-table">
      <DataGrid
        defaultPageSize={10}
        data={data}
        columns={COLUMNS}
        showPagination={false}
      />
    </div>
  );
};

WindowsEvtsTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
};

WindowsEvtsTable.defaultProps = {
  data: [],
};

export default WindowsEvtsTable;
